import React from "react";
import { useNavigate } from "react-router";
import { LOGIN_PAGE } from "../../routes";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";

const RegistrationSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <>
     <div className="blob b1"></div>
  <div className="blob b2"></div>
  <div className="wave"></div>

  <div className="wrap">
    <div className="card">
      <div className="badge" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M12 2S5 10 5 14.5 8.134 21 12 21s7-2.91 7-6.5S12 2 12 2Z" stroke="#3aa5f8" stroke-width="1.6"/>
          <path d="M9 14.8c0 1.77 1.79 3.2 3 3.2s3-1.43 3-3.2" stroke="#3aa5f8" stroke-width="1.6" stroke-linecap="round"/>
        </svg>
      </div>

      <h1>Konto zostało utworzone</h1>
      <p>
        Dziękujemy za rejestrację! Za chwilę otrzymasz e-mail
        z linkiem aktywacyjnym. Kliknij w link, aby aktywować konto.
      </p>

      <EAButton variant="filled" fullWidth title={t("zaloguj_sie")} onClick={() => navigate(LOGIN_PAGE)} />
    </div>
  </div>
    </>
    // <div className="auth-page flex-center-center">
    //   <div className="auth-box shadow">
    //     <h1>{t("konto_zostalo_pomyslnie_zalozone")}</h1>
    //     <p className="auth-description">{t("dziekujemy_za_zalozenie_konta")}</p>

    //     <div className="flex-center-center mt-4">
    //       <EAButton variant="filled" fullWidth title={t("zaloguj_sie")} onClick={() => navigate(LOGIN_PAGE)} />
    //     </div>
    //   </div>
    // </div>
  );
};

export default RegistrationSuccess;
